import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import Base from "../Base";
import BodyLocation from "./BodyLocation";

const LocationPage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / localisation"
        description="localiser nos magasins de ventes"
      />
      <Base>
        <BodyLocation />
      </Base>
    </Fragment>
  );
};

export default LocationPage;
